const prefix = (name: string): string => `panenco-bot/${name}`;

export const REPORTS = prefix('reports');
export const UNREPORTED_DAYS = prefix('unreported-days');
export const FINISHED_DAYS = prefix('finished-days');
export const PENDING_ABSENCES = prefix('pending-absences');
/** What the Phill report form opens with: the chapter it files under, and last time's products. */
export const DAILY_REPORT_DEFAULTS = prefix('daily-report-defaults');
export const PRODUCT = prefix('product');
export const SPRINT_PRODUCT_CLIENTS = prefix('sprint-product-clients');
export const SPRINT_PRODUCT_MAIL_DRAFT = prefix('sprint-product-mail-draft');
export const SPRINT_PRODUCT_PREVIOUS_RECIPIENTS = prefix('sprint-product-previous-recipients');
export const SPRINT_PRODUCT_CLIENT_URL = prefix('sprint-product-client-url');
export const PRODUCT_MANAGERS = prefix('product-managers');
export const PRODUCT_RND_DOSSIER = prefix('product-rnd-dossier');
export const PRODUCT_SENTRY_PROJECTS = prefix('product-sentry-projects');
export const PRODUCT_AIKIDO_REPOSITORIES = prefix('product-aikido-repositories');
export const PRODUCT_GITHUB_REPOSITORIES = prefix('product-github-repositories');
// One key per reading rather than one for the dashboard: each is its own request, each fails on its own,
// and each must render while its neighbours are still loading.
export const PRODUCT_RESPONSE_TIME = prefix('product-response-time');
export const PRODUCT_CRASH_FREE = prefix('product-crash-free');
export const PRODUCT_DEPENDENCIES = prefix('product-dependencies');
export const PRODUCT_SECURITY = prefix('product-security');
export const PRODUCT_QUALITY_AUDITS = prefix('product-quality-audits');
export const PRODUCT_QUALITY_AUDIT = prefix('product-quality-audit');
export const PRODUCT_PRODUCTIVITY_REPORTS = prefix('product-productivity-reports');
export const PRODUCT_PRODUCTIVITY_REPORT = prefix('product-productivity-report');
export const PRODUCT_AUDIT_REPORTS = prefix('product-audit-reports');
export const PRODUCT_AUDIT_REPORT = prefix('product-audit-report');
export const PRODUCTS = prefix('products');
export const PM_PRODUCTS = prefix('pm-products');
export const PM_SPRINT_PRODUCT_REPORTS = prefix('pm-sprint-products-reports');
export const PRODUCT_REPORTS = prefix('product-reports');
/** One person's own drafting instructions, which no organization-wide read carries. */
export const AI_SUMMARY_INSTRUCTIONS = prefix('ai-summary-instructions');
export const HOURLY_COST = prefix('hourly-cost');
export const PM_MEMBERS = prefix('pm-members');
export const PM_MEMBERS_INFINITE = prefix('pm-members-infinite');
export const PM_SPRINT_PRODUCTS = prefix('pm-sprint-products');
export const SPRINT = prefix('sprint');
export const SPRINTS = prefix('sprints');
export const TOKEN = prefix('token');
export const ROLES = prefix('roles');
export const ORGANIZATIONS = prefix('organizations');
export const ORGANIZATION = prefix('organization');
/** Slack OAuth authorize — distinct from ORGANIZATION fetch query key */
export const ORGANIZATION_SLACK_AUTHORIZE = prefix('organization-slack-authorize');
export const CLIENT_SPRINT_PRODUCTS = prefix('client-sprint-products');
export const CLIENTS = prefix('clients');
/** The organization-wide integration pickers, for a product that does not exist yet. */
export const ORGANIZATION_SENTRY_PROJECTS = prefix('organization-sentry-projects');
export const ORGANIZATION_AIKIDO_REPOSITORIES = prefix('organization-aikido-repositories');
export const ORGANIZATION_GITHUB_REPOSITORIES = prefix('organization-github-repositories');

/** The client companies we do the work for — distinct from CLIENTS, which is the people at them. */
export const CLIENT_COMPANIES = prefix('client-companies');
export const CLIENT_COMPANY = prefix('client-company');
/** What a client sees of their own end: the colleagues who read the same reports. */
export const CLIENT_COLLEAGUES = prefix('client-colleagues');
export const MY_CLIENT_COMPANIES = prefix('my-client-companies');
/** Which products a client may see. */
export const CLIENT_PRODUCTS = prefix('client-products');
// The client's own two reads, distinct from CLIENT_PRODUCTS above, which is the admin's list of what
// a client may see.
export const CLIENT_OWN_PRODUCTS = prefix('client-own-products');
export const CLIENT_PRODUCT_TIME = prefix('client-product-time');
/** The organization's own view of its sprint reports, as opposed to CLIENT_SPRINT_PRODUCTS. */
export const PM_SPRINT_PRODUCTS_LIST = prefix('pm-sprint-products-list');
export const PM_UNCLOSED_SPRINTS = prefix('pm-unclosed-sprints');
/** Who an approval or a remark goes to by default, in the two groups the dialog files them under. */
export const APPROVAL_RECIPIENTS = prefix('approval-recipients');
/** One entry per sprint, so a year already opened comes back without asking again. */
export const PM_PRODUCTS_BY_SPRINT = prefix('pm-products-by-sprint');
/** Reports whose client remark this reader has not read yet: the nav badge, the dots and the unread filter. */
export const PM_UNREAD_COMMENTS = prefix('pm-unread-comments');
/** One entry per sprint, so a sprint already opened comes back without asking again. */
export const PM_MEMBERS_BY_SPRINT = prefix('pm-members-by-sprint');
/** Which activity sources Phill holds a grant for, read from the API rather than the browser. */
export const PHILL_CONNECTIONS = prefix('phill-connections');
/** One person's reports for a single window, flat: the per-product hours card on their page. */
export const USER_REPORTS_IN_RANGE = prefix('user-reports-in-range');
/** Every incident on the organization's products, which backs the queue. */
export const ORGANIZATION_INCIDENTS = prefix('organization-incidents');
/** One product's own incident log. */
export const PRODUCT_INCIDENTS = prefix('product-incidents');

export const INCIDENT_WORK = prefix('incident-work');

export const INCIDENT_REPORT_AVAILABILITY = prefix('incident-report-availability');
export const INCIDENT_REPORT_PDF = prefix('incident-report-pdf');
export const INCIDENT_REPORT_DRAFT = prefix('incident-report-draft');
export const PRODUCT_MANAGER_RECIPIENTS = prefix('product-manager-recipients');
/** One product's budget workbook for one year. */
export const PRODUCT_BUDGET_SHEET = prefix('product-budget-sheet');
/** Everything the money tabs keep for one product. */
export const PRODUCT_STORE = prefix('product-store');
